var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { justify: "center", dense: "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12", sm: "6", md: "3" } },
        [
          _c("v-select", {
            attrs: {
              items: _vm.transportTypes,
              "item-text": "name",
              "item-value": "id",
              "error-messages": _vm.modelTransportTypeValidation,
              label: _vm.$t(
                "delegation.form.fields.transport.transportType.name"
              ),
              readonly: _vm.$store.state.Delegation.readonly === true,
              "persistent-hint": "",
              hint: _vm.validationTransportType,
              "background-color":
                _vm.validationTransportType !== null ? "blue lighten-5" : null
            },
            model: {
              value: _vm.contextTransportType,
              callback: function($$v) {
                _vm.contextTransportType = $$v
              },
              expression: "contextTransportType"
            }
          })
        ],
        1
      ),
      _vm.modelTransportType !== 1
        ? _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "3" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.settlementTypes(_vm.modelTransportType),
                  "error-messages": _vm.modelSettlementTypeIdValidation,
                  label: _vm.$t(
                    "delegation.form.fields.transport.settlementType.name"
                  ),
                  readonly: _vm.$store.state.Delegation.readonly === true
                },
                model: {
                  value: _vm.contextSettlementTypeId,
                  callback: function($$v) {
                    _vm.contextSettlementTypeId = $$v
                  },
                  expression: "contextSettlementTypeId"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-col",
        { attrs: { cols: "8", sm: "4", md: "3" } },
        [
          _c("AmountInput", {
            attrs: {
              "error-messages": _vm.modelAmountValidation,
              model: _vm.contextAmount,
              readonly: _vm.$store.state.Delegation.readonly === true
            },
            on: {
              "update:model": function($event) {
                _vm.contextAmount = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "4", sm: "2", md: "3" } },
        [
          _c("currency-select", {
            attrs: {
              model: _vm.contextCurrency,
              "validation-message": _vm.modelCurrencyValidation,
              readonly: _vm.$store.state.Delegation.readonly === true
            },
            on: {
              "update:model": function($event) {
                _vm.contextCurrency = $event
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }